// extracted by mini-css-extract-plugin
module.exports = {"companyInfo":"CompanyInfo_companyInfo__3U_lb","text":"CompanyInfo_text__c5E9j"};